import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  LinearProgress,
  Chip,
  Button,
  Input,
} from "@mui/material";
import {
  Timeline,
  TrendingUp,
  LocalFireDepartmentRounded,
  BarChartRounded,
  AccessTimeRounded,
  WorkspacePremiumRounded,
} from "@mui/icons-material";
import DashboardLayout from "../components/DashboardLayout";
import { dashboardPalette } from "../theme";
import profileIcon from "../assets/profile.png";
import LogrosCarousel from "../components/LogrosCarousel";
import ReactTimeAgo from "react-time-ago";
import useCurrentUserData from "../hooks/useCurrentUserData";
import "react-time-ago/locale/es";
import RewardedProfileDisplay from "../components/RewardedProfileDisplay";
import { renderLooseNode } from "../utils/rewards";
import { auth } from "../auth";
import { UpdateEntryImg } from "../firebase-config";
import { useAuth } from "../contexts/AuthContext";

const ProfilePage: React.FC = () => {
  const { userData } = useCurrentUserData();
  const { user } = useAuth();
  const [mainImage, setMainImage] = useState<any>();
  const userSkills = userData?.Skill ?? [];
  const userNotifications = userData?.Notifications ?? [];
  const currentExpCap = () => {
    switch (userData?.Nivel) {
      case 1:
        return 100
      case 2:
        return 250
      case 3:
        return 500
      case 4:
        return 900
      case 5:
        return 1500
      case 6:
        return 2400
      case 7:
        return 3600
      case 8:
        return 5200
      case 9:
        return 7500
      case 10:
        return 10500
      case 11:
        return 14500
      case 12:
        return 17000
      case 13:
        return 18500
      case 14:
        return 19200
      case 15:
        return 19800
      case 16:
        return 20000
      case 17:
        return 28000
      case 18:
        return 40000
    }
  }
  const maxExp = currentExpCap();
  const currentExpProgress = userData?.CurrentExp! / maxExp! * 100
  {/** 
  const currentExpProgress = Math.min(
    100,
    Math.max(0, ((userData?.CurrentExp ?? 0) * 100) / 1000),
  );*/}
  const [equippedImage, setEquippedImage] = useState(String);

  const raw = localStorage.getItem(user!.uid)
  const parsed = JSON.parse(raw!);

  useEffect(() => {
    if (user) {
      setEquippedImage(getCurrentImageReward())
    }
  }, [getCurrentImageReward()])
  //funcion improvisada para inicializar la Imagen recompensa actual
  function getCurrentImageReward() {
    for (let i = 0; parsed?.Recompensas?.length > i; i++) {
      if (parsed?.Recompensas[i]?.Equipped === true) {
        return parsed.Recompensas[i].Image
      }
    }
  }


  const panelCard = {
    backgroundColor: "var(--dashboard-panel-bg)",
    border: `3px solid ${dashboardPalette.panelBorder}`,
    borderRadius: "18px",
    boxShadow: "0 5px 0 rgba(62, 80, 147, 0.45)",
  };

  function ImgTo64(e: any) {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => {
      setMainImage(reader.result);
      UpdateEntryImg(user!.uid, mainImage)
    }
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
          backgroundColor: "var(--dashboard-page-bg)",
          minHeight: "100%",
        }}
      >
        <Card
          sx={{
            mb: 3,
            ...panelCard,
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column"
                }}>
                <RewardedProfileDisplay
                  src={userData?.PortraitImg}
                  alt="Perfil"
                  fallbackSrc={profileIcon}
                  width={120}
                  height={120}
                  border={`4px solid ${dashboardPalette.headerBlue}`}
                  boxShadow="0 4px 0 rgba(47,43,116,0.25)"
                  backgroundColor="#fff4c4"
                  rewards="{[
                    ...(userData?.Recompensas ?? []),
                    ...(userData?.Items ?? []),
                  ]}"
                />
                {equippedImage ?
                  <Box
                    sx={{
                      position: "absolute"
                    }}>
                    <Box
                      component="img"
                      src={equippedImage}
                      sx={{
                        width: 120,
                        height: 120,
                        position: "relative",
                        top: -15,
                      }}
                    />
                  </Box> : <></>}

                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    marginTop: 2,
                    marginX: "auto",
                    width: 75,
                    height: 30,

                    background: "rgba(79, 194, 134, 0.18)",
                    color: "#1f8f62",
                    fontWeight: 600,
                    border: "1px solid #1f8f62",

                    textWrap: "nowrap"
                  }}>
                  Subir Img
                  <Input
                    name="portrait"
                    type="file"
                    inputProps={{ accept: "image/png, image/gif, image/jpeg, image/jpg" }}
                    onChange={ImgTo64}
                    hidden
                    sx={{ display: "none" }} /></Button>

              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  className="outlined-title-underlined"
                  variant="h3"
                  sx={{ fontWeight: 900, mb: 1 }}
                >
                  {userData?.Nombre || "Usuario"}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{ color: "var(--dashboard-text)", mb: 2 }}
                >
                  {userData?.Email}
                </Typography>

                <Box sx={{ display: "flex", gap: 1, mb: 3, flexWrap: "wrap" }}>
                  <Chip
                    label={"Nivel " + (userData?.Nivel ?? 0)}
                    sx={{
                      background: "var(--dashboard-yellow)",
                      color: "var(--dashboard-header-blue)",
                      border: `2px solid ${dashboardPalette.accentYellowDark}`,
                      fontWeight: 800,
                    }}
                  />
                  <Chip
                    label={(userData?.CurrentExp ?? 0) + " XP"}
                    sx={{
                      background: "rgba(79, 194, 134, 0.18)",
                      color: "#1f8f62",
                      fontWeight: 600,
                      border: "1px solid #1f8f62",
                    }}
                  />
                  <Chip
                    label={(userData?.Logros?.length ?? 0) + " Logros"}
                    sx={{
                      background: "rgba(247, 197, 11, 0.2)",
                      color: "#9a7000",
                      fontWeight: 600,
                      border: `1px solid ${dashboardPalette.accentYellowDark}`,
                    }}
                  />
                </Box>

                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "var(--dashboard-text)" }}
                  >
                    Progreso al Nivel {(userData?.Nivel ?? 0) + 1}
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    value={currentExpProgress}
                    sx={{
                      flex: 1,
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: "var(--dashboard-track)",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "var(--dashboard-teal)",
                        borderRadius: 4,
                      },
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ color: "var(--dashboard-teal)", fontWeight: 700 }}
                  >
                    {Math.round(currentExpProgress)}%
                  </Typography>
                </Box>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card
              sx={{
                ...panelCard,
                mb: 3,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography
                  className="outlined-title-underlined"
                  variant="h5"
                  sx={{ fontWeight: 900, mb: 3 }}
                >
                  <BarChartRounded
                    sx={{ mr: 1, verticalAlign: "text-bottom" }}
                  />
                  Estadísticas Generales
                </Typography>

                <Grid container spacing={3}>
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: "center" }}>
                      <TrendingUp
                        sx={{ fontSize: 40, color: "#1bdb6b", mb: 1 }}
                      />
                      <Typography
                        variant="h4"
                        sx={{ color: "#1bdb6b", fontWeight: 800 }}
                      >
                        {userSkills.length}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#2d1b69" }}>
                        Skills Totales
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: "center" }}>
                      <Timeline
                        sx={{ fontSize: 40, color: "#ff6ddd", mb: 1 }}
                      />
                      <Typography
                        variant="h4"
                        sx={{ color: "#ff6ddd", fontWeight: 800 }}
                      >
                        {userSkills.length > 0
                          ? Math.round(
                            userSkills.reduce(
                              (acc, skill) => acc + skill.Progress,
                              0,
                            ) / userSkills.length,
                          )
                          : 0}
                        %
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#2d1b69" }}>
                        Promedio
                      </Typography>
                    </Box>
                  </Grid>
                  {/*
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: "center" }}>
                      <EmojiEvents
                        sx={{ fontSize: 40, color: "#feca52", mb: 1 }}
                      />
                      <Typography
                        variant="h4"
                        sx={{ color: "#feca52", fontWeight: 800 }}
                      >
                        {userData?.Logros?.length}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#2d1b69" }}>
                        Logros
                      </Typography>
                    </Box>
                  </Grid>
 */}

                  {/** 
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: "center" }}>
                      <LocalFireDepartmentRounded
                        sx={{ fontSize: 40, color: "#5f7bd7", mb: 1 }}
                      />
                      <Typography
                        variant="h4"
                        sx={{ color: "#5f7bd7", fontWeight: 800 }}
                      >
                        7
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#2d1b69" }}>
                        Días Racha
                      </Typography>
                    </Box>
                  </Grid>
                  */}
                </Grid>
              </CardContent>
            </Card>

            <Card
              sx={{
                ...panelCard,
              }}
            >
              {userData && userData.Logros.length >= 1 ? (
                <CardContent sx={{ p: 3 }}>
                  <Typography
                    className="outlined-title-underlined"
                    variant="h5"
                    sx={{ fontWeight: 900, mb: 3 }}
                  >
                    <WorkspacePremiumRounded
                      sx={{ mr: 1, verticalAlign: "text-bottom" }}
                    />
                    Logros
                  </Typography>

                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <LogrosCarousel></LogrosCarousel>

                    {/**
                  {achievements.map((achievement) => (
                    <Box
                      key={achievement.id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        p: 2,
                        borderRadius: "16px",
                        background: achievement.completed
                          ? "rgba(79, 194, 134, 0.15)"
                          : "#fff",
                        border: achievement.completed
                          ? "1px solid rgba(79, 194, 134, 0.5)"
                          : `1px solid ${dashboardPalette.panelBorder}`,
                        opacity: achievement.completed ? 1 : 0.6,
                      }}
                    >
                      <Typography sx={{ fontSize: "32px", mr: 2 }}>
                        {achievement.icon}
                      </Typography>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{ color: "#2d1b69", fontWeight: 700 }}
                        >
                          {achievement.name}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#2d1b69" }}>
                          {achievement.description}
                        </Typography>
                      </Box>
                      {achievement.completed && (
                        <Chip
                          label="Completado"
                          size="small"
                          sx={{
                            background: "var(--dashboard-teal)",
                            color: "#fff",
                            fontWeight: 600,
                          }}
                        />
                      )}
                    </Box>
                  ))} 
                   */}
                  </Box>
                </CardContent>
              ) : (
                <></>
              )}
            </Card>
          </Grid>

          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <Card
              sx={{
                ...panelCard,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              <CardContent
                sx={{
                  p: 3,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Typography
                  className="outlined-title-underlined"
                  variant="h6"
                  sx={{ fontWeight: 900, mb: 3 }}
                >
                  <AccessTimeRounded
                    sx={{ mr: 1, verticalAlign: "text-bottom" }}
                  />
                  Actividad Reciente
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    flex: 1,
                  }}
                >
                  {userNotifications.map((notif, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        p: 2,
                        borderRadius: "8px",
                        background: "#fff",
                        border: `1px solid ${dashboardPalette.panelBorder}`,
                      }}
                    >
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "50%",
                          mr: 1.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        {renderLooseNode(
                          notif.Icon,
                          <AccessTimeRounded
                            sx={{ fontSize: 18, color: "#5f7bd7" }}
                          />,
                        )}
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#2d1b69",
                            fontWeight: 600,
                            lineHeight: 1.2,
                          }}
                        >
                          {notif.Title}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#6c6c6c" }}>
                          {notif.Date ? (
                            <ReactTimeAgo
                              date={notif.Date.seconds * 1000}
                              locale="es"
                            />
                          ) : (
                            <></>
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </DashboardLayout>
  );
};

export default ProfilePage;
